import { Formik, Form, Field } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";
import ErrorList from "../components/Form/ErrorList";
import { useRef } from "react";
import { handleSubmitClick } from "../components/Form/FormUtils";
import BackButton from "../components/Buttons/BackButton";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

export const WITH_APP = "in_app";
export const WITH_TRAVELCARD = "with_travelcard";
export const WITH_BLIP = "with_blip";
export const WITH_TICKET = "with_ticket";
export const WITH_OTHER = "with_other";

export default function PaymentMethod() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);

    return (
        <div>
            <Formik<FormModel>
                onSubmit={(values) => {
                    setFormData({
                        ...formData,
                        ...values,
                    });

                    if (values.paymentmethod === WITH_APP) {
                        navigate("/med-app");
                    } else if (values.paymentmethod === WITH_TRAVELCARD) {
                        navigate("/med-resekort");
                    } else if (values.paymentmethod === WITH_BLIP) {
                        navigate("/med-blipp");
                    } else if (values.paymentmethod === WITH_TICKET) {
                        navigate("/med-biljett");
                    } else if (values.paymentmethod === WITH_OTHER) {
                        navigate("/ersattning-for");
                    }

                }}
                initialValues={{
                    ...formData,
                }}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={Yup.object().shape({
                    paymentmethod: Yup.string().test(
                        "at-least-one-radio-selected",
                        "Vänligen välj ett svarsalternativ för att gå vidare till nästa steg",
                        (value) => {
                            return value === WITH_APP ||
                                value === WITH_TRAVELCARD ||
                                value === WITH_BLIP ||
                                value === WITH_TICKET ||
                                value === WITH_OTHER;
                        }
                    ),
                })}
            >
                {({ errors, values }) => (
                    <>
                        <div className="flex justify-end items-center">
                            <div className="xs:w-52 md:w-full max-w-xs md:mb-4">
                                <Progressbar percentage={"30"} />
                            </div>
                        </div>
                        <Form noValidate>
                            <Box>
                                <h2 ref={h2Ref} tabIndex={-1} id="paymentMethod">
                                    Var hade du din biljett?
                                </h2>

                                {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}

                                <div
                                    role="radiogroup"
                                    aria-labelledby="paymentMethod"
                                    className="radio-group"
                                >
                                    {errors.paymentmethod && (
                                        <span
                                            aria-describedby="forMe forOther"
                                            className="validation-error"
                                        >
                                            {errors.paymentmethod.toString()}
                                        </span>
                                    )}

                                    <div className={errors.paymentmethod ? "has-error" : ""}>
                                        <Field
                                            id="withApp"
                                            type="radio"
                                            name="paymentmethod"
                                            value={WITH_APP}
                                            checked={values.paymentmethod === WITH_APP}
                                        />
                                        <label htmlFor="withApp">I appen</label>
                                    </div>

                                    <div className={errors.paymentmethod ? "has-error" : ""}>
                                        <Field
                                            id="withTravelcard"
                                            type="radio"
                                            name="paymentmethod"
                                            value={WITH_TRAVELCARD}
                                            checked={values.paymentmethod === WITH_TRAVELCARD}
                                        />
                                        <label htmlFor="withTravelcard">
                                            På ett reskort
                                        </label>
                                    </div>

                                    <div className={errors.paymentmethod ? "has-error" : ""}>
                                        <Field
                                            id="withBlip"
                                            type="radio"
                                            name="paymentmethod"
                                            value={WITH_BLIP}
                                            checked={values.paymentmethod === WITH_BLIP}
                                        />
                                        <label htmlFor="withBlip">
                                            Blippat bankkort ombord
                                        </label>
                                    </div>

                                    <div className={errors.paymentmethod ? "has-error" : ""}>
                                        <Field
                                            id="withTicket"
                                            type="radio"
                                            name="paymentmethod"
                                            value={WITH_TICKET}
                                            checked={values.paymentmethod === WITH_TICKET}
                                        />
                                        <label htmlFor="withTicket">
                                            Pappersbiljett
                                        </label>
                                    </div>

                                    <div className={errors.paymentmethod ? "has-error" : ""}>
                                        <Field
                                            id="withOther"
                                            type="radio"
                                            name="paymentmethod"
                                            value={WITH_OTHER}
                                            checked={values.paymentmethod === WITH_OTHER}
                                        />
                                        <label htmlFor="withOther">
                                            Inget av ovanstående/jag hade ingen biljett
                                        </label>
                                    </div>


                                </div>
                            </Box>

                            <div className="flex justify-center">
                                <div className="w-full text-left flex items-center">
                                    <BackButton />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Gå vidare
                                    </button>
                                </div>
                            </div>

                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}
